import {
  rehydrateAdjustableTableStore,
  resetAdjustableTableStore,
} from './adjustableTable.store'
import {
  rehydrateAssignedTaskInfoStore,
  resetAssignedTaskInfoStore,
} from './assignedTaskInfo.store'
import { rehydrateFeaturesStore, resetFeaturesStore } from './features.store'
import {
  rehydratePinnedItemsStore,
  resetPinnedItemsStore,
} from './pinnedItems.store'
import { rehydrateRecentsStore, resetRecentsStore } from './recents.store'
import { rehydrateUserModeStore, resetUserModeStore } from './userMode.store'
import {
  rehydrateWorkspaceLayoutStore,
  resetWorkspaceLayoutStore,
} from './workspaceLayout.store'

export const rehydrateUserStores = () => {
  rehydrateRecentsStore()
  rehydratePinnedItemsStore()
  rehydrateFeaturesStore()
  rehydrateAdjustableTableStore()
  rehydrateUserModeStore()
  rehydrateAssignedTaskInfoStore()
  rehydrateWorkspaceLayoutStore()
}

export const resetUserStores = () => {
  resetRecentsStore()
  resetPinnedItemsStore()
  resetFeaturesStore()
  resetAdjustableTableStore()
  resetUserModeStore()
  resetAssignedTaskInfoStore()
  resetWorkspaceLayoutStore()
}
